"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseModifiers = exports.unregisterEventHandlers = exports.registerEventHandlers = void 0;
/**
 * Calls addEventListener on the provided handlers
 * @deprecated
 */
const registerEventHandlers = handlers => {
    if (!Array.isArray(handlers)) {
        return;
    }
    for (const handler of handlers) {
        handler.target.addEventListener(handler.eventName, handler.callback, handler.capture);
    }
};
exports.registerEventHandlers = registerEventHandlers;
/**
 * Calls removeEventListener on the provided handlers
 * @deprecated
 */
const unregisterEventHandlers = handlers => {
    if (!Array.isArray(handlers)) {
        return;
    }
    for (const handler of handlers) {
        handler.target.removeEventListener(handler.eventName, handler.callback, handler.capture);
    }
};
exports.unregisterEventHandlers = unregisterEventHandlers;
/**
 * This method exists as a best effort to parse old style modifiers for offset into the new format.
 * It's not exhaustive and will not work in all cases.
 *
 * We only provided modifiers of form: { offset: { offset: '0, 7' } } even though old popper (v1)
 * suppored additional formats, see https://popper.js.org/docs/v1/#modifiers..offset
 *
 * New format docs https://floating-ui.com/docs/offset
 * @deprecated
 */
const parseModifiers = modifiers => {
    const offsetValue = modifiers?.offset?.offset;
    // no offset value
    if (!offsetValue) {
        return null;
    }
    // if number, return it
    if (typeof offsetValue === 'number') {
        return offsetValue;
    }
    // if function, return it
    if (typeof offsetValue === 'function') {
        return offsetValue;
    }
    // if not string, return null
    if (typeof offsetValue !== 'string') {
        return null;
    }
    // if string, parse it and return an AxesOffset compatible object https://floating-ui.com/docs/offset
    if (offsetValue.includes(',')) {
        const [crossAxis, mainAxis] = offsetValue.split(',');
        return {
            mainAxis: parseInt(mainAxis, 10),
            crossAxis: parseInt(crossAxis, 10),
        };
    }
    // if string, return it as number
    return parseInt(offsetValue, 10);
};
exports.parseModifiers = parseModifiers;
